import ServiceFetch from '../../utilities/ServiceFetch.js';
import IowsStoreTransformer from './IowsStoreTransformer.js';
/**
 * This class is used for fetching and parsing store data for IRW.
 */
export default class IowsStoreService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.consumer Consumer.
     * @param options.contract Contract.
     * @param options.endpoint Endpoint.
     */
    constructor(options) {
        this.consumer = options.consumer;
        this.contract = options.contract;
        this.endpoint = options.endpoint;
    }
    /**
     * Fetches and returns stores.
     *
     * @returns Promise object.
     */
    async getStores() {
        const transformer = new IowsStoreTransformer();
        const response = await ServiceFetch.json(this.endpoint, {
            credentials: 'same-origin',
            headers: {
                accept: 'application/vnd.ikea.irms+json; version=2',
                'auth-token': this.consumer + '-' + this.contract,
                contract: this.contract,
                consumer: this.consumer
            }
        });
        return transformer.transform(response);
    }
}
//# sourceMappingURL=IowsStoreService.js.map